import { YMapLocation } from "@yandex/ymaps3-types/imperative/YMap";
import * as YMaps from "@yandex/ymaps3-types";
import {parsePhoneNumberFromString} from "libphonenumber-js"

export const features: YMaps.YMapFeatureProps[] = [
    {
        id: "1",
        style: {
            fillRule: "nonzero",
            fill: "var(--map-no-data-color)",
            fillOpacity: 0.6,
            stroke: [
                {
                    color: "var(--map-no-data-color)",
                    width: 5,
                },
            ],
        },
        geometry: {
            type: "Polygon",
            coordinates: [
                [
                    [37.8, 55.8],
                    [37.8, 55.75],
                    [37.9, 55.75],
                    [37.9, 55.8],
                ],
            ],
        },
        properties: { hint: "Polygon 1" },
    },
    {
        id: "2",
        style: {
            fillRule: "nonzero",
            fill: "var(--map-success-color)",
            fillOpacity: 0.6,
            stroke: [
                {
                    color: "var(--map-success-color)",
                    width: 5,
                },
            ],
        },
        geometry: {
            type: "Polygon",
            coordinates: [
                [
                    [37.9, 55.8],
                    [37.9, 55.75],
                    [38.0, 55.75],
                    [38.0, 55.8],
                ],
            ],
        },
        properties: { hint: "Polygon 2" },
    },
    {
        id: "3",
        style: {
            fillRule: "nonzero",
            fill: "var(--map-danger-color)",
            fillOpacity: 0.6,
            stroke: [
                {
                    color: "var(--map-danger-color)",
                    width: 5,
                },
            ],
        },
        geometry: {
            type: "Polygon",
            coordinates: [
                [
                    [38.0, 55.8],
                    [38.0, 55.75],
                    [38.1, 55.75],
                    [38.1, 55.8],
                ],
            ],
        },
        properties: { hint: "Polygon 3" },
    },
];

export const location: YMapLocation = { center: [37.95, 55.65], zoom: 10 };
// apikey is only for codesandbox.io, xk3d74.csb.app and wxn9cy.csb.app
export const apiKey = "30888d84-d5cc-4242-b612-e9119a293983";

export function formatInternationalPhoneNumber(phoneNumber:any, countryCode:any) {
    const phoneNumberInstance = parsePhoneNumberFromString(phoneNumber, countryCode);
    if (!phoneNumberInstance) return phoneNumber;

    let formattedNumber = phoneNumberInstance.formatNational();

    // Проверяем, если это Россия, заменяем 8 на +7
    if (countryCode === 'RU' || phoneNumberInstance.countryCallingCode === '7') {
        // Заменяем "8" на "+7"
        formattedNumber = `+7 ${formattedNumber.slice(1)}`;
    }

    return formattedNumber;
}

export const formatPrice = (value: number, locale = 'ru-RU', currency = 'RUB') => {
    let formattedValue = Number(value).toFixed(2);

    if (formattedValue.endsWith('.00')) {
        formattedValue = parseInt(formattedValue, 10).toString();
    }

    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
    }).format(Number(formattedValue)).replace('₽','');
};

export function getQuarter(dateString: any) {
    const date = new Date(dateString);
    const month = date.getMonth();
    const quarter = Math.floor(month / 3) + 1;
    return quarter;
}

export function convertToRoman(number:number){
    return [
        { value: 1000, char: 'M' },
        { value: 900, char: 'CM' },
        { value: 500, char: 'D' },
        { value: 400, char: 'CD' },
        { value: 100, char: 'C' },
        { value: 90, char: 'XC' },
        { value: 50, char: 'L' },
        { value: 40, char: 'XL' },
        { value: 10, char: 'X' },
        { value: 9, char: 'IX' },
        { value: 5, char: 'V' },
        { value: 4, char: 'IV' },
        { value: 1, char: 'I' }
    ].reduce((result, currentValue) => {
        while (number >= currentValue.value) {
            result += currentValue.char;
            number -= currentValue.value;
        }

        return result;
    }, '');
}

export function convertToQuarter(dateString: string): string | null {
    if (!dateString) return null;

    // Берём только дату (без времени)
    const [datePart] = dateString.split(' ');
    const [year, month] = datePart.split('-').map(Number);

    if (!year || !month) {
        console.error('Invalid date format:', dateString);
        return null;
    }

    const quarter = Math.ceil(month / 3);
    return `${quarter} кв. ${year}`;
}

export function getNoun(number:number, one:string, two:string, five:string) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) {
        return five;
    }
    n %= 10;
    if (n === 1) {
        return one;
    }
    if (n >= 2 && n <= 4) {
        return two;
    }
    return five;
}

export const normalizePriceString = (price: string): string => {
    const normalized = price.replace(',', '.');
    const number = parseFloat(normalized);

    if (isNaN(number)) return price;

    return number.toFixed(2);
};

// правило склонения
export const getPluralForm = (count: number, forms: [string, string, string]) => {
    const mod10 = count % 10;
    const mod100 = count % 100;

    if (mod10 === 1 && mod100 !== 11) return forms[0]; // 1 объект
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1]; // 2-4 объекта
    return forms[2]; // 5+ объектов
};